var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-0"},[_c('vue-skeleton-loader',{staticClass:"mt-6",attrs:{"width":210,"height":20}}),_c('vue-skeleton-loader',{staticClass:"mt-4",attrs:{"width":160,"height":40}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }